<template>
<div>
    <b-card header-tag="header">
      <template #header>
        <div class="d-flex justify-content-between">
          <h4 class="mb-0 fw-bold">จำนวนพัสดุที่ตกค้าง</h4>
          <b-button pill variant="primary" size="sm" @click="onReload()" :disabled="busy">
            <i class="fas fa-sync-alt"></i>
          </b-button>
        </div>
      </template>
      <b-table 
        responsive
        :items="items"
        :fields="fields"
        :busy="busy"
        head-variant="light"
      >
        <template #table-busy>
          <div class="d-flex align-items-center justify-content-center">
            <div class="circle-loading"></div>
            <span class="ml-2">กำลังโหลดข้อมูล...</span>
          </div>
        </template>
      </b-table>
    </b-card>
</div>
</template>
<script>
import columns from './js/columnsBacklog'
export default {
  data(){
    return {
      fields: columns,
      busy: true,
      items: [
        { 
          total: 0,
          to_day: 0,
          yesterday: 0,
          two_days_ago: 0,
          three_days_ago: 0,
          more_than_four_days: 0
        }
      ]
    }
  },
  async mounted(){
    await this.backLogOrdersAPI()
  },
  methods:{
    onReload(){
      this.backLogOrdersAPI()
    },
    async backLogOrdersAPI(){
      this.isloading()
      const uri = '/shop/backlog/orders'
      const header = {
        headers: {
          Token: localStorage.getItem("access_token")
        }
      }
      const res = await this.$http.get( this.$API_URL + uri, header)
      try{
        let data = res.data
        if( data.status === true ){
          this.items = [data.data]
        }
      } catch ( e ){
        console.info( e )
      }
      this.isLoaded()
    },
    isloading(){
      this.busy = true
      return this.busy
    },
    isLoaded(){
      this.busy = false
      return this.busy
    }
  }
}
</script>